import PlayAreaSvg from "@assets/images/svg/children-play-area.svg";
import React from "react";
import { View } from "react-native";

export interface PlayAreaIconProps {
  size?: number;
  color?: string;
}

export function ChildrenPlayAreaIcon({
  size = 24,
  color = "#4D4D4D",
}: PlayAreaIconProps) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <PlayAreaSvg width={size} height={size} color={color} />
    </View>
  );
}

export default ChildrenPlayAreaIcon;
